import closest from './closest';
import '../padStart/index';
import '../matches/index';
/* eslint-disable */

if (typeof window !== 'undefined' && window.Element && !Element.prototype.closest) {
  Element.prototype.closest = closest;
}
/* eslint-enable */